import { Home } from 'containers/home'
import { DataProvider } from 'context/data-context'
import { GlobalStyle } from 'styles/global'

function App() {
  return (
    <DataProvider>
      <GlobalStyle />
      <Home />
    </DataProvider>
  )
}

export default App
